<div class="container">
  <lib-content-card-list
    *ngIf="pickerItem"
    backLink="/videos"
    [item]="pickerItem"
    [videoType]="videoType">
  </lib-content-card-list>
</div>
